module.exports = __webpack_public_path__ + "static/media/ipko.c976aac5.svg";